import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from './app/app'
import { ThemeProvider } from '@mui/material/styles'
import theme from './theme'

const root = createRoot(document.getElementById('app') as HTMLElement)

root.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
)
